"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-lib/lib/constants");

var _SetIntervalMixin = _interopRequireDefault(require("composer-lib/lib/SetIntervalMixin"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var MINUTE_MS = 1000 * 60;

var langKey = function langKey(key) {
  return "composer-lib.header.saveStatus." + key;
};

var SaveStatus = (0, _createReactClass.default)({
  displayName: "SaveStatus",
  mixins: [_SetIntervalMixin.default],
  propTypes: {
    compositionLastUpdated: _propTypes.default.number,
    getAuthor: _propTypes.default.func.isRequired,
    locked: _propTypes.default.bool,
    status: _propTypes.default.oneOf(Object.keys(_constants.RequestStatus).map(function (key) {
      return _constants.RequestStatus[key];
    }))
  },
  componentDidMount: function componentDidMount() {
    // have to force updates on the minute because otherwise React will only
    // update the save status when you're actually typing
    this.setInterval(this.updateSaveStatus, MINUTE_MS);
  },
  updateSaveStatus: function updateSaveStatus() {
    this.forceUpdate();
  },
  getTimestampString: function getTimestampString(fromNow) {
    var _this$props = this.props,
        getAuthor = _this$props.getAuthor,
        locked = _this$props.locked;

    var _getAuthor = getAuthor(),
        firstName = _getAuthor.firstName,
        lastName = _getAuthor.lastName;

    var text = langKey('savedAt');

    if (locked) {
      text = langKey('updated');
    } // translate updatedBy to user name


    return _I18n.default.text(text, {
      firstName: firstName,
      fromNow: fromNow,
      lastName: lastName
    });
  },
  getLastSavedString: function getLastSavedString() {
    var compositionLastUpdated = this.props.compositionLastUpdated;

    if (!compositionLastUpdated) {
      return '';
    }

    var fromNow = _I18n.default.moment(compositionLastUpdated).fromNow();

    return this.getTimestampString(fromNow);
  },
  getSavedStatus: function getSavedStatus() {
    return _react.default.createElement(_UITooltip.default, {
      placement: "bottom",
      title: this.getLastSavedString()
    }, _react.default.createElement("span", {
      className: "saved"
    }, _react.default.createElement(_UIIcon.default, {
      className: "m-right-1",
      name: "success"
    }), _react.default.createElement(_FormattedHTMLMessage.default, {
      message: langKey('saved')
    })));
  },
  getClassNames: function getClassNames() {
    var locked = this.props.locked;
    return (0, _classnames.default)('save-status-container', {
      locked: locked
    });
  },
  renderStatus: function renderStatus() {
    var status = this.props.status;

    if (status === _constants.RequestStatus.UNINITIALIZED) {
      return null;
    }

    if (status === _constants.RequestStatus.PENDING) {
      return _react.default.createElement("div", null, _react.default.createElement(_UIIcon.default, {
        className: "m-right-1",
        name: "refresh"
      }), _react.default.createElement(_FormattedHTMLMessage.default, {
        message: langKey('saving')
      }));
    }

    return this.getSavedStatus();
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: this.getClassNames()
    }, _react.default.createElement("span", {
      className: "save-status"
    }, this.renderStatus()));
  }
});
var _default = SaveStatus;
exports.default = _default;
module.exports = exports.default;